<template>
  <v-sheet class="order-content__block" elevation="0" rounded>
    <!-- <p class="sheet-title">{{ $t('refund_detail_title') }}</p> -->
    <p class="sheet-title">{{ $t('all_cancel') }}</p>
    <div class="order-content__block__content">
      <div class="payment-detail-content">
        <div class="content-block">
          <p class="content-block__label">{{ $t('cancelled_time') }}</p>

          <div class="content-block__context">
            <div class="block-text">{{ cancelTimeText }}</div>
          </div>
        </div>

        <div v-if="!isGiftOrder && isPaymentPaid">
          <!-- <div> -->
          <div v-if="funCoinFeedback || isRefundPromo" class="content-block">
            <p class="content-block__label">{{ $t('cancel_content') }}</p>

            <div class="content-block__context">
              <div v-if="isRefundPromo" class="block-text d-flex align-center justify-content-between">
                <!-- promotion refund label -->
                <div style="min-width: fit-content">{{ $t('billing_promo') }}</div>
                <div style="max-width: 192px">
                  <div class="block-text--right">
                    <div class="mb-1">{{ $t('refund_detail_refunded') }}</div>
                  </div>
                  <!-- promotion refund data information -->
                  <div class="d-flex justify-end mb-4">
                    <div class="block-text--right">
                      <p class="hint-text">{{ promosText }}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="funCoinFeedback" class="block-text">
                <div class="d-flex align-center">
                  <span> {{ $t('fun_coin_refunded') }} </span>
                  <funnow-icon class="mr-2" max-width="16" :image-path="'fun_coins.svg'" />
                </div>

                <div class="block-text--right">
                  <p class="mb-1">{{ funCoinFeedback }}</p>
                </div>
              </div>
            </div>
          </div>

          <div class="content-block">
            <div class="content-block__context">
              <div class="block-text">
                <span> {{ $t('refund_fee') }} </span>
                <span class="wd-text-orange50"> {{ refundAmount }} </span>
              </div>
            </div>
          </div>

          <p class="hint-text py-3 wd-px-5 sm:wd-px-0">{{ $t('order_detail_3rd_party_payment_refund_notice') }}</p>
        </div>
      </div>
    </div>
  </v-sheet>
</template>

<script setup lang="ts">
import FunnowIcon from '@/components/icons/funnow-icon.vue'
import type { OrderDetail } from '@/view-models/order'

type Props = {
  order: OrderDetail
}

defineOptions({
  name: 'RefundDetailSheet',
})

const props = withDefaults(defineProps<Props>(), {
  order: () => ({} as OrderDetail),
})

const { t } = useI18n()
const { $dayjs } = useNuxtApp()

const refundAmount = computed(() => {
  if (props.order?.txn_info) {
    if (props.order?.txn_info.refund) {
      return `${props.order?.symbol_code} ${props.order?.txn_info.refund}`
    }
  }
  return t('refund_in_process')
})

const cancelTimeText = computed(() =>
  props.order?.cancel_date ? $dayjs(props.order?.cancel_date, { utc: true }).local().format('YYYY/MM/DD HH:mm') : ''
)

const promosText = computed(
  () =>
    props.order?.promos
      ?.filter((p: any) => p.has_refund && p.refund_quantity)
      .map((p: any) => (p.refund_quantity > 1 ? `${p.refund_quantity}x ${p.name}` : p.name))
      .join(' + ') || ''
)

const isRefundPromo = computed(() => !!promosText.value.length)

const funCoinFeedback = computed(() => props.order?.return_bonus)

const isGiftOrder = computed(() => !!props.order?.is_gift)

const isPaymentPaid = computed(() => props.order?.has_paid)
</script>
<style lang="scss" scoped>
.payment-detail-content {
  .content-block {
    &__context {
      .block-text {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        &--right {
          text-align: right;
        }
      }
    }
  }

  .hint-text {
    margin-bottom: 0;
    font-size: 14px;
    color: $gray80;
  }
}
</style>
